import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.includes('OrgVRazonesSociales')
    && !req.url.includes('ListadoProveedorMKTP')
    && !req.url.includes('Buscar')
    && !req.url.includes('ListarOrgc')
    && !req.url.includes('ExcelMKTP')
    && !req.url.includes('Vendedores')
    && !req.url.includes('UsuariosVenta')
    && !req.url.includes('ImprimirDocumento')
    && !req.url.includes('Historial')
    && !req.url.includes('UtilizaImpuestoLineas')
    && !req.url.includes('ListarPrecios')
    && !req.url.includes('GetAttached')
          ){

      this.showLoader();
    }



    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if(!req.url.includes('OrgVRazonesSociales')
        && !req.url.includes('ListadoProveedorMKTP')
        && !req.url.includes('Buscar')
        && !req.url.includes('ListarOrgc')
        && !req.url.includes('ExcelMKTP')
        && !req.url.includes('Vendedores')
        && !req.url.includes('UsuariosVenta')
        && !req.url.includes('ImprimirDocumento')
        && !req.url.includes('Historial')
        && !req.url.includes('UtilizaImpuestoLineas')
        && !req.url.includes('ListarPrecios')
        && !req.url.includes('GetAttached')
          ){
          this.onEnd();
        }

      }
    },
      (err: any) => {
        this.onEnd();
      }));
  }
  private onEnd(): void {
      this.hideLoader();
  }
  private showLoader(): void {
    this.loaderService.show();
  }
  private hideLoader(): void {
    this.loaderService.hide();
  }

}
